import { gql } from '@apollo/client';

export const GET_CORE_LOOP_CONFIGURATION = gql`
  query GetCoreLoopConfiguration($tenantId: String!) {
    getCoreLoopConfiguration(tenantId: $tenantId) {
      id
      configuration
    }
  }
`;
